import { NumericFormat } from "react-number-format";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { Tooltip } from "@wealthx/ui";
import "./menu-left-item.scss";

const MenuLeftItemWValue = ({
  icon,
  name,
  value,
  className = "",
  isNetItem = false,
  info = "",
}) => {
  return (
    <div className={`ml-transaction-body ${className}`}>
      {icon && (
        <div className="ml-icon-container">
          <img alt={name} src={icon} />
        </div>
      )}
      <div className="ml-transaction-value">
        <div className="ml-transaction-value-container">
          <div className={isNetItem ? "ml-net-item-name" : ""}>{name}</div>
          {info && (
            <Tooltip title={info} placement="top" className="menu-left-item-value__tooltip">
              <div className="ml-info-value">
                <InfoOutlineIcon fontSize="16px" />
              </div>
            </Tooltip>
          )}
        </div>
        <div className="ml-bank-value">
          <NumericFormat
            value={value}
            displayType="text"
            thousandSeparator
            prefix="$"
            renderText={(formattedValue) =>
              isNetItem && Number(value) > 0 ? `+${formattedValue}` : formattedValue
            }
          />
        </div>
      </div>
    </div>
  );
};

export default MenuLeftItemWValue;
